/**
 * Notice Block - Interactivity API View Script
 *
 * One action: hide the notice. The dismissal is not remembered — see the note
 * in render.php for why that is a decision rather than an omission.
 *
 * @package BrandyBlocks
 */

import { store, getContext } from '@wordpress/interactivity';

store( 'brandy/notice', {
	actions: {
		dismiss() {
			getContext().dismissed = true;
		},
	},
} );
